import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider,CircularProgress } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import { getRawdemandInfoByVendorAPI } from '../RawdemandAPI';


export default function RawdemandListTableRow({ obj, getActionComponent, handleRowClick }) {
  const dispatch = useDispatch();

  const { productrawList } = useSelector((state) => state.pharmaslice);
  const { rmvendorquotationList } = useSelector((state) => state.pharmaslice);
  const {rawdemandObj} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);
  const {rawdemandList} = useSelector((state)=>state.pharmaslice);
  const {apiInProgress} = useSelector((state)=>state.headerslice);
  const [rmList, setRmList] = useState([])
  useEffect(() => {

  }, [rawdemandList])

  const getAssignedDemandForVendor = (obj) =>{
    console.log("obj=>"+JSON.stringify(obj));
    getRawdemandInfoByVendorAPI(obj.vendorid, setRmList, ()=>{})
  }

  const getRMbySelectedVendorId = (vendorId) =>{
    return rawdemandList.filter(rawdemandObj=> rawdemandObj.vendorid===vendorId)
  }

  return (

    <>
      <Grid item sx={{ width: '100%' }}>
        <Grid container direction="row" onClick={() => {getAssignedDemandForVendor(obj)}}
          sx={{
            //cursor:'pointer',
            justifyContent: "flex-start", alignItems: "center", 
            '&:hover': {
              backgroundColor: 'secondary.lighter', color: 'primary.main'
            },
          }}
        >
          <Grid item lg={4} xs={2} sx={{paddingLeft:2}}><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.vendorname!==''?obj.vendorname:'---'}</Typography></Grid>
          <Grid item lg={8} xs={2} >
            <Grid container direction="row" sx={{ backgroundColor: '#fafafa', width:'100%', justifyContent: "flex-end", alignItems: "center"}} >
                    {
                      getRMbySelectedVendorId(obj.vendorid).map(demandObj => {
                        return (
                          <Grid item lg={6} sx={{width:'100%'}}><FieldView label={demandObj.title} value={demandObj.qty +' '+demandObj.unit} /></Grid>
                        )
                      })
                    }
              </Grid>
          </Grid>
          <Grid item lg={12} xs={2} sx={{backgroundColor:'primary.200', padding:.1}}>

          </Grid>
        </Grid>
      </Grid>
      
    </>

  )
}